import { defineAsyncComponent } from '../../lib/utils/vue3compat/vue.js?vue3';
import { s__ } from '~/locale';
import BoardsSelector from '../../../../../ee/app/assets/javascripts/boards/components/boards_selector.vue?vue3';
import IssueBoardFilteredSearch from '../../../../../ee/app/assets/javascripts/boards/components/issue_board_filtered_search.vue?vue3';
import { getBoardQuery } from 'ee_else_ce/boards/boards_util';
import { setError } from '../graphql/cache_updates.js?vue3';
import ConfigToggle from './config_toggle.vue?vue3';
import ToggleFocus from './toggle_focus.vue?vue3';
import BoardOptions from './board_options.vue?vue3';
export default {
    name: 'BoardTopBar',
    components: {
        BoardOptions,
        BoardsSelector,
        IssueBoardFilteredSearch,
        ConfigToggle,
        ToggleFocus,
        EpicBoardFilteredSearch: defineAsyncComponent(()=>import('../../../../../ee/app/assets/javascripts/boards/components/epic_filtered_search.vue?vue3'))
    },
    inject: [
        'swimlanesFeatureAvailable',
        'isSignedIn',
        'isIssueBoard',
        'fullPath',
        'boardType',
        'isEpicBoard'
    ],
    props: {
        boardId: {
            type: String,
            required: true
        },
        isSwimlanesOn: {
            type: Boolean,
            required: true
        },
        filters: {
            type: Object,
            required: true
        }
    },
    emits: [
        'set-filters',
        'switch-board',
        'toggle-swimlanes',
        'update-board'
    ],
    data () {
        return {
            board: {},
            currentForm: ''
        };
    },
    apollo: {
        board: {
            query () {
                return getBoardQuery(this.boardType, this.isEpicBoard);
            },
            variables () {
                return {
                    fullPath: this.fullPath,
                    boardId: this.boardId
                };
            },
            update (data) {
                const { board } = data.namespace;
                return {
                    ...board,
                    labels: board.labels?.nodes
                };
            },
            error (error) {
                setError({
                    error,
                    message: s__('Boards|An error occurred while fetching board details. Please try again.')
                });
            }
        }
    },
    computed: {
        isLoading () {
            return this.$apollo.queries.board.loading;
        }
    },
    methods: {
        setCurrentForm (formType) {
            this.currentForm = formType;
        }
    }
};
